{
  "success": {
    "default": "Vorgang erfolgreich",
    "save": "Gespeichert",
    "remove": "Erfolgreiche Entfernung",
    "detach": {
      "user": "Der folgende Benutzer wurde vom Sektor { sectorName } getrennt | Die folgenden Benutzer wurden vom Sektor { sectorName } getrennt",
      "device": "Das folgende Gerät wurde vom Sektor { sectorName } getrennt | Die folgenden Geräte wurden vom Sektor { sectorName } getrennt",
      "application": "Die folgende Anwendung wurde vom Sektor { sectorName } getrennt | Die folgenden Anwendungen wurden vom Sektor { sectorName } getrennt",
      "userGroup": "Die folgende Benutzergruppe wurde vom Sektor { sectorName } getrennt | Die folgenden Benutzergruppen wurden vom Sektor { sectorName } getrennt",
      "dtwins": "Das folgende Gerät wurde vom Sektor { sectorName } getrennt | Die folgenden Geräte wurden vom Sektor { sectorName } getrennt"
    },
    "attach": {
      "user": "Der folgende Benutzer wurde dem Sektor { sectorName } hinzugefügt | Die folgenden Benutzer wurden dem Sektor { sectorName } hinzugefügt",
      "device": "Das folgende Gerät wurde dem Sektor { sectorName } hinzugefügt | Die folgenden Geräte wurden dem Sektor { sectorName } hinzugefügt",
      "application": "Die folgende Anwendung wurde dem Sektor { sectorName } hinzugefügt | Die folgenden Anwendungen wurden dem Sektor { sectorName } hinzugefügt",
      "userGroup": "Die folgende Benutzergruppe wurde dem Sektor { sectorName } hinzugefügt | Die folgenden Benutzergruppen wurden dem Sektor { sectorName } hinzugefügt",
      "dtwins": "Das folgende Gerät wurde dem Sektor { sectorName } hinzugefügt | Die folgenden Geräte wurden dem Sektor { sectorName } hinzugefügt"
    },
    "certificate": {
      "generation": "Das Benutzerzertifikat wurde erfolgreich generiert."
    }
  },
  "cancellation": {
    "cancel": "Bearbeitung abgebrochen"
  },
  "inProgress": {
    "save": "Speichern wird durchgeführt"
  },
  "error": {
    "default": "Es ist ein Fehler aufgetreten",
    "unexpectedApiError": "Unerwarteter API-Fehler",
    "save": "Speichern fehlgeschlagen",
    "remove": "Die Entfernung war nicht erfolgreich",
    "upload": "Hochladen fehlgeschlagen, bitte versuchen Sie es erneut",
    "detach": {
      "user": "Die Trennung des folgenden Benutzers vom Sektor { sectorName } ist fehlgeschlagen | Die Trennung der folgenden Benutzer vom Sektor { sectorName } ist fehlgeschlagen",
      "device": "Das Entfernen des folgenden Geräts aus dem Sektor { sectorName } ist fehlgeschlagen | Das Entfernen der folgenden Geräte aus dem Sektor { sectorName } ist fehlgeschlagen",
      "application": "Das Entfernen der folgenden Anwendung aus dem Sektor { sectorName } ist fehlgeschlagen | Das Entfernen der folgenden Anwendungen aus dem Sektor { sectorName } ist fehlgeschlagen",
      "userGroup": "Das Entfernen der folgenden Benutzergruppe aus dem Sektor { sectorName } ist fehlgeschlagen | Das Entfernen der folgenden Benutzergruppen aus dem Sektor { sectorName } ist fehlgeschlagen",
      "dtwins": "Das Entfernen des folgenden Geräts aus dem Sektor { sectorName } ist fehlgeschlagen | Das Entfernen der folgenden Geräte aus dem Sektor { sectorName } ist fehlgeschlagen"
    },
    "attach": {
      "user": "Das Hinzufügen des folgenden Benutzers zum Sektor { sectorName } ist fehlgeschlagen | Das Hinzufügen der folgenden Benutzer zum Sektor { sectorName } ist fehlgeschlagen",
      "device": "Das Hinzufügen des folgenden Geräts zum Sektor { sectorName } ist fehlgeschlagen | Das Hinzufügen der folgenden Geräte zum Sektor { sectorName } ist fehlgeschlagen",
      "application": "Das Hinzufügen der folgenden Anwendung zum Sektor { sectorName } ist fehlgeschlagen | Das Hinzufügen der folgenden Anwendungen zum Sektor { sectorName } ist fehlgeschlagen",
      "userGroup": "Das Hinzufügen der folgenden Benutzergruppe zum Sektor { sectorName } ist fehlgeschlagen | Das Hinzufügen der folgenden Benutzergruppen zum Sektor { sectorName } ist fehlgeschlagen",
      "dtwins": "Das Hinzufügen des folgenden Geräts zum Sektor { sectorName } ist fehlgeschlagen | Das Hinzufügen der folgenden Geräte zum Sektor { sectorName } ist fehlgeschlagen"
    },
    "campaign": {
      "firmware": "Firmware-Update konnte nicht für das gewünschte Datum geplant werden"
    },
    "startDate": "Die Kampagne hat bereits begonnen, Sie können das Start- und Enddatum nicht ändern.",
    "keystore": {
      "aliasAlreadyUsed": {
        "title": "Alias wird bereits verwendet",
        "message": "Verwenden Sie einen anderen Zertifikatalias und versuchen Sie es erneut."
      }
    },
    "certificate": {
      "parsing": "Zertifikatsfehler",
      "notValid": "Der Wert des API-Zertifikats ist ungültig"
    }
  }
}
